import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{yield}}")